import React from 'react';
import { TwoColumnLayout } from '../../../components/layouts';
import { DomainMain } from './DomainMain';
import { DomainSide } from './DomainSide';

export function Domain() {
  return (
    <TwoColumnLayout
      mainContent={<DomainMain />}
      sideContent={<DomainSide />}
      mainContentSpan={6}
      sideCellStyle={{ maxWidth: '550px' }}
    />
  );
}
